<template>
    <section class="login">


         <div class="inner">
             <img class="logo" src="../assets/img/logo.png">

            <h1>Login form</h1>
             <form class="form" @submit.prevent="login">
                <div>
                    <label>Email</label>
                    <input type="text" v-model="email">
                </div>
                <div>
                    <label>Password</label>
                    <input type="password" v-model="password">
                </div>
                <div>
                    <input type="submit" value="Invia">
                </div>
            </form>
         </div>

    </section>
</template>



<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'login',
    data () {
        return {
            email: '',
            password: '',
            errorMessage: ''  // nuovo stato per gestire errori
        }
    },
    computed: {
        ...mapGetters(['isAuthenticated'])
    },
    methods: {
        ...mapActions({
            logout: 'logout'
        }),
        login () {
            // Reset messaggio errore
            this.errorMessage = ''

            // Validazione email
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!this.email || !emailRegex.test(this.email)) {
                this.errorMessage = 'Inserisci un\'email valida.'
                return
            }

            // Validazione password
            if (!this.password) {
                this.errorMessage = 'La password non può essere vuota.'
                return
            }

            // Se tutto ok, effettua il login
            this.$store.dispatch('login', {
                urlToConnect: 'login',
                methodToConnect: 'post',
                email: this.email,
                password: this.password
            })
                .then(() => {
                    this.email = ''
                    this.password = ''
                    this.$router.replace('/dashboard')
                })
                .catch(err => {
                    this.errorMessage = 'Credenziali non valide.'
                })
        }
    },
    created () {
        if (this.$store.getters.isAuthenticated) {
            this.$router.replace('/dashboard')
        }
    }
}
</script>

